export default __webpack_public_path__ + "static/swish-anvandare-43121a1692079acb1b4faabd3126ba14.jpg";